import Vue from 'vue'
import { Storage } from '@capacitor/storage'

import { DefaultContractIdGQL } from '@/graphql/queries'

import hasActiveContracts from '@/mixins/hasActiveContracts'

const STORAGE_KEY = 'currContractId'

const cachedState = Vue.observable({
  defaultContractId: null,
  contractId: null
})

export let currContractIdVar

export default {
  mixins: [hasActiveContracts],

  apollo: {
    defaultContractId: {
      query: DefaultContractIdGQL,
      update: data => data.merchant.defaultContractId,
      skip () { return !this.hasActiveContracts }
    }
  },

  watch: {
    defaultContractId (val, oldVal) {
      if (val !== oldVal) {
        cachedState.defaultContractId = val
      }
    },

    contractId (val, oldVal) {
      if (val !== oldVal) {
        cachedState.contractId = val
      }
    },

    currContractId (val) {
      currContractIdVar = val
    }
  },

  data () {
    return {
      contractId: null
    }
  },

  computed: {
    currContractId: {
      get () {
        if (cachedState.contractId) {
          return +cachedState.contractId
        } else if (cachedState.defaultContractId) {
          return +cachedState.defaultContractId
        }

        return null
      },

      async set (val) {
        await this.setContract(val)
      }
    }
  },

  methods: {
    async $_initContractFromCache () {
      this.contractId = (await this.$storage.get({
        key: STORAGE_KEY
      })).value || null
    },

    $_setContract (e) {
      this.contractId = e.detail.contractId
    },

    async setContract (contractId) {
      const contractChangeEvent = new CustomEvent('onContractChange', {
        detail: { contractId }
      })

      window.dispatchEvent(contractChangeEvent)

      await this.$storage.set({
        key: STORAGE_KEY,
        value: contractId
      })
    }
  },

  async created () {
    window.addEventListener('onContractChange', this.$_setContract)
    await this.$_initContractFromCache()
  },

  beforeDestroy () {
    window.removeEventListener('onContractChange', this.$_setContract)
  }
}

export const clearContractId = async () => {
  cachedState.defaultContractId = null
  cachedState.contractId = null
  await Storage.remove({ key: STORAGE_KEY })
}
